import request from '../utils/request'
import setting from './apiSetting'

const TYPE = 'Location'

const myfunction = {
  /**
   * 获取轨迹点列表头
   */
  GetColumns: function (name) {
    return request({
      url: setting.getFullUrl(TYPE, name),
      method: 'post',
    })
  },

  getDetailPhoto: function (p) {
    return request({
      url: setting.getFullUrl(TYPE, 'GetDetailPic'),
      method: 'post',
      data: p,
    })
  },
  getDetailPhotoByID: function (p) {
    return request({
      url: setting.getFullUrl(TYPE, 'GetPictureByID'),
      method: 'post',
      data: p,
    })
  },
  /**
   * 导出轨迹点到Excel
   */
  exportReport: function (formData) {
    return request({
      url: setting.getFullUrl(TYPE, 'ExportExcel'),
      method: 'post',
      data: formData,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('ms_token'),
        'Accept-Language': localStorage.getItem('language'),
      },
      responseType: 'blob',
    })
  },

  /**
   * 获取所有设备最后定位信息
   */
  GetAllLastLocations: function (p) {
    return request({
      url: setting.getFullUrl(TYPE, 'GetAllLastLocations'),
      method: 'post',
      data: p,
      // 登录后首页初始化依赖此请求。后端 User_Tracker_View 的全列查询平均就要 4~5 秒，
      // 10s 太紧会必定超时且无法自愈（超时→trackerMap 为空→下轮仍是全量→再超时），
      // 这里放宽到 60s；仍低于 request.js 的 120s 默认值，避免卡死整轮定时循环。
      timeout: 60000,
    })
  },

  /**
   * 获取所有设备最后定位信息列数据
   */
  GetLastLocationColumns: function () {
    return request({
      url: setting.getFullUrl(TYPE, 'GetLastLocationColumns'),
      method: 'post',
    })
  },

  GetLastLocations: function (formData) {
    return request({
      url: setting.getFullUrl(TYPE, 'GetLastLocations'),
      method: 'post',
      data: formData,
    })
  },

  /**
   * 获取设备最后位置信息
   */
  GetLastLocation: function (params) {
    return request({
      url: setting.getFullUrl(TYPE, 'GetLastLocation'),
      method: 'get',
      params: params,
    })
  },

  /**
   * 获取报警列数据
   */
  GetAlarmColumns: function () {
    return request({
      url: setting.getFullUrl(TYPE, 'GetAlarmColumns'),
      method: 'post',
    })
  },

  /**
   * 获取报警数据
   */
  GetOBDDatas: function (formData) {
    return request({
      url: setting.getFullUrl(TYPE, 'GetObdDatas'),
      method: 'post',
      data: formData,
    })
  },

  /**
   * 获取报警数据
   */
  GetAlarms: function (formData) {
    return request({
      url: setting.getFullUrl(TYPE, 'GetAlarms'),
      method: 'post',
      data: formData,
    })
  },

  /**
   * 获取历史数据
   */
  getHistoria: function (formData) {
    return request({
      url: setting.getFullUrl(TYPE, 'GetHistories'),
      method: 'post',
      data: formData,
    })
  },

  /**
   * 获取行程和中间停车数据
   */
  getTripParking: function (formData) {
    return request({
      url: setting.getFullUrl(TYPE, 'GetTripAndParking'),
      method: 'post',
      data: formData,
    })
  },

  /**
   * 获取行程数据
   */
  getTrip: function (formData) {
    return request({
      url: setting.getFullUrl(TYPE, 'GetTripAndParking'),
      method: 'post',
      data: formData,
    })
  },

  /**
   * 获取停车数据
   */
  getParking: function (formData) {
    return request({
      url: setting.getFullUrl(TYPE, 'GetTripAndParking'),
      method: 'post',
      data: formData,
    })
  },
}

export default myfunction
